import React, {useState, useEffect, useRef} from 'react'
import { useVerticalSecondaryModule } from './useVerticalSecondaryModule'
import sanitizeHtml from 'sanitize-html'
import { CustomTitleTag } from '../../utils/utils'
import ImageRenditions from '../GenericComponents/ImageRenditions/ImageRenditions'
import RoutedLink from '../RouterLink/RoutedLink'
import './VerticalSecondaryModule.scss'
import { VerticalSecondaryModuleEditConfig } from './VerticalSecondaryModuleEditConfig'
import { ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { ModelManager } from '@adobe/aem-spa-page-model-manager';
import { scrollIntoComponent } from '../../utils/scrollIntoComponent'
import { ReactComponent as ArrowForwardIcon } from '../../styles/icons/arrowForward.svg';

const VerticalSecondaryModule = ({ verticalSecondaryModule, ...props }) => {
  /** Component name */
  const cmpName = 'vertical-sec-mod'
  /** Var names */
  const {
    description,
    eyebrow,
    featureText,
    featureTextColor,
    featureBackgroundColor,
    iconFont,
    image,
    order,
    primaryButton,
    secondaryButton,
    textStyle,
    title,
    titleType,
    backgroundColor,
    borderColor,
    buttonAppliedCssClassNames,
    onlyIconFont,
    onlyImage,
    video,
    renderType,
    textInfo1,
    textInfo2,
    imageInfo1,
    imageInfo2
  } = useVerticalSecondaryModule({verticalSecondaryModule, appliedCssClassNames: props?.appliedCssClassNames})


  const [state, setState] = useState({ isCustom: false, XF: <></>})
  const { scrollIntoView } = scrollIntoComponent(props.id, props.isInEditor);
  useEffect(
    () => {
      window.addEventListener("change-xf", handleChangeState, false);
      const timerRef = scrollIntoView();
      return () => {
        window.removeEventListener("change-xf", handleChangeState, false)
        if (timerRef){
          clearTimeout(timerRef);
        }
      };
    }, []
  )

  const fetchData = (pathXF) => {
    ModelManager.getData(`${pathXF}/jcr:content/root`).then(res => {
        if(!res[':type'].includes('wcm')){ // es para no renderizar nada si no se encuentra el path del xf dado
            let ItemComponent = 
                <ResponsiveGrid 
                    cqPath={`${pathXF}/jcr:content/root`}
                    cqItems={res[':items']} 
                    cqItemsOrder={res[':itemsOrder']} 
                    gridClassNames={res.gridClassNames}
                />
            setState({
                isCustom: true,
                XF: ItemComponent
            })
        }else{
            throw new Error(`error al cargar xf ${pathXF}`)
        }
    }).catch(err => console.error(err))
}

const handleChangeState = (event) => {
    if(event.detail){
        let {moduleId, pathXF} = event.detail
        if((moduleId && pathXF) && (moduleId === props.id) ){
            fetchData(pathXF)
        }
    }
}
const renderBorderColor = ()=> {
  if (borderColor){
    return {
      border: `2px solid ${ borderColor }`
    }
  }
}
  
  if (state.isCustom) {
    return (state.XF)
  }

  return (
    <>
      {(!VerticalSecondaryModuleEditConfig.isEmpty({ verticalSecondaryModule, ...props }) || props.isInEditor) && (
        <article id={props.id} role='article' className={`${cmpName} ${order} ${renderType === "compact" ? `${cmpName}--compact` : ''}`} style={{backgroundColor, ...renderBorderColor()}}>

          {/* CONTENT */}
          <div className={`${cmpName}__content ${renderType === "compact" ? `${cmpName}__content--compact` : ''}`}>

            {(iconFont && onlyIconFont) && (
              <div className={`${cmpName}__iconFont`}> 
                <i className={`${iconFont}`} />
              </div>
            )}
            {featureText &&(
                <label className={`${cmpName}__featureText ${order}`}
                style={{ color: featureTextColor,  backgroundColor: featureBackgroundColor }}>
                      {featureText}
                </label>
            )}            
            {eyebrow && renderType !== "compact" && (
              <span 
                className={`${cmpName}__eyebrow eyebrow`} 
                style={{ color: textStyle?.eyebrowColor || '' }}
              >
                {eyebrow}
              </span>
            )}
            {
              renderType === "compact" && (textInfo1 || textInfo2) && (
                <div className={`${cmpName}__info-text--compact`}>
                  {
                    (imageInfo1.path || textInfo1) && (
                      <div className={`${cmpName}__group-info-text--compact`}> 
                        {
                          imageInfo1.path && (
                            <ImageRenditions image={imageInfo1} />
                          )
                        }
                        {
                          textInfo1 && (
                            <span>{textInfo1}</span>
                          )
                        }
                      </div>
                    )
                  }
                  {
                    (imageInfo2.path || textInfo2) && (
                      <div className={`${cmpName}__group-info-text--compact`}> 
                        {
                          imageInfo2.path && (
                            <ImageRenditions image={imageInfo2} />
                          )
                        }
                        {
                          textInfo2 && (
                            <span>{textInfo2}</span>
                          )
                        }
                      </div>
                    )
                  }
                </div>
              )
            }

            {title && (
              <CustomTitleTag 
                tag={titleType}
                title={title}
                className={`${cmpName}__title ${renderType === "compact" ? `${cmpName}__title--compact` : ''}`} 
                style={{ color: textStyle?.titleColor || '' }}
                htmlPermission
              />
            )}

            {description && (
              <div
                className={`${cmpName}__description rteEditor body-l ${renderType === "compact" ? `${cmpName}__description--compact` : ''}`}
                dangerouslySetInnerHTML={{
                    __html: sanitizeHtml(description),
                  }}
                style={{ color: textStyle?.textColor }}
              />
            )}
          </div>
          {/* IMAGE */}
          {(image?.path && onlyImage && !video) && (
            <div className={`${cmpName}__image ${renderType === "compact" ? `${cmpName}__image--compact` : ''}`}>
              {featureText &&(
                <label className={`${cmpName}__featureText ${order} ${renderType === "compact" ? `${cmpName}__featureText--compact` : ''}`}
                    style={{ color: featureTextColor,  backgroundColor: featureBackgroundColor }}>
                      {featureText}
                </label>
              )}
              <ImageRenditions isDisableZoom={verticalSecondaryModule?.iszoomdisabled ? true : false} image={image} />
            </div>
          )}

          {/* VIDEO */}
          {(video && (video.split(".").slice(-1) == "mp4" || video.split(".").slice(-1) == "webm" || video.split(".").slice(-1) == "MP4" || video.split(".").slice(-1) == "WEBM")) && (
            <div className={`${cmpName}__image ${renderType === "compact" ? `${cmpName}__image--compact` : ''}`}>
              {featureText &&(
                <label className={`${cmpName}__featureText`}
                    style={{ color: featureTextColor,  backgroundColor: featureBackgroundColor }}>
                      {featureText}
                </label>
              )}
              <video autoPlay loop muted playsInline >
                <source src={`${video}`}/>
              </video>
            </div>
          )}

          {/* ACTIONS */}
          {(primaryButton?.url || secondaryButton?.url) && (
            <div className={`${cmpName}__actions ${renderType === "compact" ? `${cmpName}__actions--compact` : ''}`}>
              {primaryButton?.url && (
                <RoutedLink
                  className={`btn primary ${primaryButton?.buttonColor} ${primaryButton?.alignment} ${buttonAppliedCssClassNames} ${renderType === "compact" ? `${cmpName}__btn-custom--compact` : ''}`}
                  to={primaryButton?.url}
                  target={primaryButton?.target}
                  componentTree={['Módulo Secundario Vertical', title]}
                  label={primaryButton?.text}
                  isCustomEvent={verticalSecondaryModule.custom}
                >
                  {primaryButton?.iconfont && renderType !== "compact" && (<i className={`${primaryButton?.iconfont}`}></i>)}
                  {renderType === "compact" && <ArrowForwardIcon className='arrow-icon' />}
                  {primaryButton?.text}
                </RoutedLink>
              )}
      
              {secondaryButton?.url && (
                <RoutedLink
                  className={`btn secondary ${secondaryButton?.buttonColor} ${secondaryButton?.alignment} ${buttonAppliedCssClassNames} ${renderType === "compact" ? `${cmpName}__btn-custom--compact` : ''}`}
                  to={secondaryButton?.url}
                  target={secondaryButton?.target}
                  componentTree={['Módulo Secundario Vertical', title]}
                  label={secondaryButton?.text}
                  isCustomEvent={verticalSecondaryModule.custom}
                >
                  {secondaryButton?.iconfont && renderType !== "compact" && (<i className={`${secondaryButton?.iconfont}`}></i>)}
                  {secondaryButton?.text}
                  {renderType === "compact" && <ArrowForwardIcon className='arrow-icon' />}
                </RoutedLink>
              )}
            </div>
          )}

        </article>
      )}
    </>
  )
}

export default VerticalSecondaryModule